import { Injectable } from "@angular/core";

@Injectable()
export class GfxCommonHelper {
    getObjectPropertyByPath = (path,object) => {
        return path.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, object)
    }
}